import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'notification-message',
	templateUrl: './notification-message.component.html',
	styleUrls: ['./notification-message.component.scss'],
    imports:[CommonModule, TranslatePipe,  MatDialogModule, 
        MatButtonModule,
        MatDialogActions, 
        MatDialogClose, 
        MatDialogTitle, 
        MatDialogContent]
})
export class NotificationMessageComponent {
	constructor(
		public dialogRef: MatDialogRef<NotificationMessageComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {type: string; title: string; message: string}
	) {
	}

    onConfirmClick(): void {
        this.dialogRef.close();
    }
}
